import React, { useState, useEffect } from 'react';
import { X, Ship } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';

const SellBoatPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Don't show popup on the sell page
    if (location.pathname === '/vendre-mon-bateau') {
      return;
    }

    // Check if popup was already closed in this session
    const popupClosed = sessionStorage.getItem('sellBoatPopupClosed');
    if (popupClosed) {
      setIsClosed(true);
      return;
    }

    // Show popup after 5 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  const handleClose = () => {
    setIsVisible(false);
    setIsClosed(true);
    sessionStorage.setItem('sellBoatPopupClosed', 'true');
  };

  if (isClosed || !isVisible || location.pathname === '/vendre-mon-bateau' || location.pathname.startsWith('/admin') || location.pathname.startsWith('/bateaux-a-vendre')) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-slide-up">
      <div className="max-w-4xl mx-auto bg-gradient-to-r from-[#1a1c1b] to-[#302f2c] border-2 border-[#d9fb06] rounded-xl p-6 shadow-2xl relative">
        {/* Close button */}
        <button 
          onClick={handleClose}
          className="absolute top-3 right-3 text-[#888680] hover:text-[#d9fb06] transition-colors"
          aria-label="Fermer"
        >
          <X size={24} />
        </button>

        <div className="flex flex-col md:flex-row items-center gap-6">
          {/* Icon */}
          <div className="bg-[#d9fb06] p-4 rounded-full flex-shrink-0">
            <Ship className="text-[#1a1c1b]" size={32} />
          </div>

          {/* Content */}
          <div className="flex-grow text-center md:text-left">
            <h3 className="text-xl md:text-2xl font-bold text-[#d9fb06] mb-2">
              Estimation gratuite de votre bateau par un expert
            </h3>
            <p className="text-[#dfddd6] text-sm md:text-base">
              Combien vaut votre bateau ? Obtenez une estimation précise et sans engagement.
            </p>
          </div>

          {/* CTA Button */}
          <Link to="/vendre-mon-bateau" className="flex-shrink-0">
            <Button 
              className="bg-[#d9fb06] text-[#1a1c1b] hover:bg-[#c4e205] font-bold px-6 py-3 rounded-full text-base uppercase tracking-wide whitespace-nowrap"
            >
              Estimer mon bateau
            </Button>
          </Link>
        </div>
      </div>

      <style>{`
        @keyframes slide-up {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        .animate-slide-up {
          animation: slide-up 0.5s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default SellBoatPopup;
